enum FeatureFlagKeysEnum {
  tenant = 'tenant',
  email = 'email',
  anonymous = 'anonymous',
  tenantId = 'tenantId',
  fqTenantId = 'fqTenantId',
  portalName = 'portalName',
  idpId = 'idpId'
}

export default FeatureFlagKeysEnum;
